const ADD_TO_CART = "ADD_TO_CART";
const DELETE_FROM_CART = "DELETE_FROM_CART";
const RESET_CART = "RESET_CART";
const REDUCE_CART_ITEMS = "REDUCE_CART_ITEMS";
const ADD_CART_ITEMS = "ADD_CART_ITEMS";
const APPLY_COUPON = "APPLY_COUPON";

export {
  ADD_TO_CART,
  DELETE_FROM_CART,
  RESET_CART,
  REDUCE_CART_ITEMS,
  ADD_CART_ITEMS,
  APPLY_COUPON
};
